import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectContactConfig,
  selectContactFormErrors,
  selectIdentityContactSubscriptionData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  addClientError,
  removeClientError,
  updateClientData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { subscriptionFormActionsV2 } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormV2Sagas'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

const FISCAL_CODE_LENGTH_BY_COUNTRY = {
  it: 16,
}

const useFiscalCode = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { taxIdCode } = useSelector(selectIdentityContactSubscriptionData)
  const errors = useSelector(selectContactFormErrors)
  const { fiscalCodeIsLoading, fiscalCodeIsValid } = useSelector(selectContactConfig)
  const { isEditable } = useFormStatus()
  const { country } = useSelector(selectAuthData)
  // @ts-ignore
  const customerConfig = modulesConfig[country]?.customer ?? {}

  const fiscalCodeLength = FISCAL_CODE_LENGTH_BY_COUNTRY[country as keyof typeof FISCAL_CODE_LENGTH_BY_COUNTRY]
  const label = mandatoryTag + t('subscriptionForm:customer_module.taxIdCode.label')
  const error = getError('taxIdCode', errors)

  const getStatus = () => {
    if (fiscalCodeIsLoading) return 'loading'

    if (fiscalCodeIsValid === true) return 'valid'

    if (fiscalCodeIsValid === false) return 'error'

    return undefined
  }

  const onBlur = (value: string | null) => {
    // @ts-ignore
    dispatch(removeClientError('taxIdCode'))
    // @ts-ignore
    dispatch(updateClientData({ data: { fiscalCodeIsValid: null }, name: 'config' }))
    // @ts-ignore
    dispatch(updateClientData({ data: { taxIdCode: value }, name: 'identity' }))
    const trimmed = (value ?? '').trim()
    if (fiscalCodeLength && trimmed.length === fiscalCodeLength) {
      dispatch({ type: subscriptionFormActionsV2.CONTACT_MODULE_VERIFY_ITALY_FISCAL_CODE_V2, fiscalCode: trimmed })
      return
    }
    // @ts-ignore
    dispatch(addClientError({ key: 'taxIdCode', message: t('subscriptionForm:customer_module.taxIdCode.invalid') }))
  }

  return {
    taxIdCode,
    label,
    error,
    isEditable,
    status: getStatus(),
    onBlur,
    hidden: !customerConfig.taxIdCode,
  }
}

export default useFiscalCode
